var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pb-5" },
    [
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12" } },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "mt-n3",
              attrs: { color: "transparent", flat: "", height: "45" },
            },
            [
              _c("v-spacer"),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mr-n2",
                      attrs: {
                        align: "center",
                        justify: "end",
                        "no-gutters": "",
                      },
                    },
                    [
                      _vm.$helpers.hasSomePermission([
                        "view_member",
                        "view_invitation",
                      ])
                        ? [
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-click": "",
                                  "close-on-content-click": "",
                                  "offset-y": "",
                                  left: "",
                                  "nudge-bottom": 10,
                                  transition: "slide-y-transition",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "ml-2",
                                                  attrs: { outlined: "" },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("mdi-export-variant")]
                                              ),
                                              _vm._v("Exportar"),
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "18",
                                                    right: "",
                                                  },
                                                },
                                                [_vm._v("mdi-chevron-down")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2284898498
                                ),
                              },
                              [
                                _c(
                                  "v-list",
                                  { staticClass: "pa-0" },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        staticClass: "px-3",
                                        attrs: { ripple: false },
                                        on: {
                                          click: function ($event) {
                                            return _vm.createExport("members")
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [_vm._v("Usuarios")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item",
                                      {
                                        staticClass: "px-3",
                                        attrs: { ripple: false },
                                        on: {
                                          click: function ($event) {
                                            return _vm.createExport(
                                              "invitations"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [_vm._v("Invitaciones pendientes")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-query-builder", {
                              staticClass: "mx-2",
                              attrs: {
                                "query-map": _vm.filters,
                                model: "member",
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm.$helpers.hasPermission(["add_invitation"])
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "grey-900" },
                              on: {
                                click: function ($event) {
                                  _vm.dialogCreate = true
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-account-plus"),
                              ]),
                              _vm._v("Invitar usuario"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "px-0", attrs: { cols: "12" } },
        [
          _vm.activeMembersList.length &&
          ["Active", null].includes(
            ((_vm.$route || {}).query || {}).status || null
          )
            ? _c(
                "v-toolbar-title",
                { staticClass: "subtitle-1 grey-700--text font-weight-bold" },
                [_vm._v("Usuarios activos")]
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.$store.state.accounts.LoaderMe
        ? [
            !_vm.$helpers.hasSomePermission(["view_member", "view_invitation"])
              ? _c("PermissionDenied")
              : [
                  _vm.loadingActiveMembers
                    ? _c("skeleton-list")
                    : ["Active", null].includes(
                        ((_vm.$route || {}).query || {}).status || null
                      )
                    ? [
                        _c(
                          "v-col",
                          { staticClass: "pa-0", attrs: { cols: "12" } },
                          [
                            _c(
                              "v-row",
                              _vm._l(
                                _vm.activeMembersList,
                                function (d, index) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: `${d.id}-${index}`,
                                      attrs: {
                                        cols: "4",
                                        md:
                                          _vm.$vuetify.breakpoint.width < 1200
                                            ? 3
                                            : 2,
                                      },
                                    },
                                    [
                                      _c("v-hover", {
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ hover }) {
                                                return [
                                                  _c(
                                                    "v-card",
                                                    {
                                                      staticClass:
                                                        "pa-5 rounded-md",
                                                      style: `cursor:${
                                                        _vm.$helpers.hasPermission(
                                                          ["change_member"]
                                                        )
                                                          ? "pointer"
                                                          : "default"
                                                      }`,
                                                      attrs: {
                                                        elevation:
                                                          _vm.$helpers.hasPermission(
                                                            ["change_member"]
                                                          ) && hover
                                                            ? 5
                                                            : 0,
                                                        flat: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$router.replace(
                                                            {
                                                              name: "AccountMemberUpdate",
                                                              params: {
                                                                id: d.id,
                                                                ..._vm.currentParams,
                                                              },
                                                            }
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey-background",
                                                                right: "",
                                                                width: "160px",
                                                                "open-on-hover":
                                                                  d.is_owner,
                                                                "open-on-click": false,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-icon",
                                                                            _vm._g(
                                                                              {
                                                                                staticClass:
                                                                                  "mb-1",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "grey-900",
                                                                                  },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-account" +
                                                                                  _vm._s(
                                                                                    !d.is_owner
                                                                                      ? ""
                                                                                      : "-star"
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-block px-3 py-2",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Dueño del espacio"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("v-spacer"),
                                                          _c(
                                                            "v-menu",
                                                            {
                                                              attrs: {
                                                                "close-on-click":
                                                                  "",
                                                                "offset-y": "",
                                                                left: "",
                                                                "nudge-bottom": 0,
                                                                "nudge-left": 25,
                                                                transition:
                                                                  "slide-y-transition",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                        attrs,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              _vm._b(
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-n1 mr-n2",
                                                                                  attrs:
                                                                                    {
                                                                                      text: "",
                                                                                      ripple: false,
                                                                                    },
                                                                                },
                                                                                "v-btn",
                                                                                attrs,
                                                                                false
                                                                              ),
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      color:
                                                                                        "grey-700",
                                                                                      size: "24",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-dots-vertical"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .menuActiveMember[
                                                                    index
                                                                  ],
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.menuActiveMember,
                                                                      index,
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "menuActiveMember[index]",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list",
                                                                {
                                                                  staticClass:
                                                                    "pa-0",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "px-3",
                                                                      attrs: {
                                                                        ripple: false,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.$router.replace(
                                                                              {
                                                                                name: "AccountMemberUpdate",
                                                                                params:
                                                                                  {
                                                                                    id: d.id,
                                                                                    ..._vm.currentParams,
                                                                                  },
                                                                              }
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticClass:
                                                                            "body-2",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Ver información del usuario"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-block",
                                                        },
                                                        [
                                                          _c(
                                                            "v-sheet",
                                                            {
                                                              staticClass:
                                                                "transparent",
                                                              attrs: {
                                                                height: "25",
                                                              },
                                                            },
                                                            [
                                                              d.first_name
                                                                .length &&
                                                              d.first_name !==
                                                                " "
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "grey-700--text font-weight-medium body-1 d-inline-block text-truncate",
                                                                      staticStyle:
                                                                        {
                                                                          "max-width":
                                                                            "99%",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-capitalize",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "lower"
                                                                              )(
                                                                                d.first_name
                                                                              )
                                                                            ) +
                                                                              " " +
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "lower"
                                                                                )(
                                                                                  d.last_name
                                                                                )
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 text--disabled font-italic",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Sin especificar"
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      d.email.length
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mt-n2 d-block body-2 grey-300--text d-inline-block text-truncate",
                                                              staticStyle: {
                                                                "max-width":
                                                                  "99%",
                                                                "line-height":
                                                                  "22px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(d.email)
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-block mt-n1 body-2 text--disabled font-italic",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Sin especificar"
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                            (_vm.showPagination || _vm.showAll) &&
                            _vm.activeMembersList.length
                              ? _c("VMainPagination", {
                                  attrs: {
                                    count: _vm.activeMembersList?.length,
                                    currentPage: _vm.currentPageActive,
                                  },
                                  on: {
                                    isActive: function ($event) {
                                      return _vm.setQueryMembers(
                                        $event,
                                        "Active"
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.loadingInvitations
                    ? _c("skeleton-list")
                    : ["Accepted", null].includes(
                        ((_vm.$route || {}).query || {}).status || null
                      )
                    ? [
                        _vm.invitationsList.length &&
                        _vm.$helpers.hasPermission(["view_invitation"])
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-0",
                                  class: _vm.activeMembersList.length
                                    ? "mt-2"
                                    : "mt-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-toolbar-title",
                                    {
                                      staticClass:
                                        "subtitle-1 grey-700--text font-weight-bold",
                                    },
                                    [_vm._v("Invitaciones pendientes")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-row",
                                    _vm._l(
                                      _vm.invitationsList,
                                      function (d, index) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: `${d.id}-${index}`,
                                            attrs: {
                                              cols: "5",
                                              md:
                                                _vm.$vuetify.breakpoint.width <
                                                1300
                                                  ? 4
                                                  : 3,
                                              xl: "2",
                                            },
                                          },
                                          [
                                            _c("v-hover", {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ hover }) {
                                                      return [
                                                        _c(
                                                          "v-card",
                                                          {
                                                            staticClass:
                                                              "pa-5 rounded-md",
                                                            attrs: {
                                                              elevation: hover
                                                                ? 5
                                                                : 0,
                                                              flat: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                attrs: {
                                                                  "no-gutters":
                                                                    "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mb-1",
                                                                    attrs: {
                                                                      color:
                                                                        "grey-900",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-account"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("v-spacer"),
                                                                _c(
                                                                  "v-menu",
                                                                  {
                                                                    attrs: {
                                                                      "close-on-click":
                                                                        "",
                                                                      "offset-y":
                                                                        "",
                                                                      left: "",
                                                                      "nudge-bottom": 0,
                                                                      "nudge-left": 25,
                                                                      transition:
                                                                        "slide-y-transition",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "activator",
                                                                            fn: function ({
                                                                              on,
                                                                              attrs,
                                                                            }) {
                                                                              return [
                                                                                _c(
                                                                                  "v-btn",
                                                                                  _vm._g(
                                                                                    _vm._b(
                                                                                      {
                                                                                        staticClass:
                                                                                          "mt-n1 mr-n2",
                                                                                        attrs:
                                                                                          {
                                                                                            text: "",
                                                                                            ripple: false,
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.menuInvitation[
                                                                                                index
                                                                                              ] = true
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      "v-btn",
                                                                                      attrs,
                                                                                      false
                                                                                    ),
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "grey-700",
                                                                                            size: "24",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-dots-vertical"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .menuInvitation[
                                                                          index
                                                                        ],
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.menuInvitation,
                                                                            index,
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "menuInvitation[index]",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                      },
                                                                      [
                                                                        _vm.$helpers.hasPermission(
                                                                          [
                                                                            "add_invitation",
                                                                          ]
                                                                        ) &&
                                                                        _vm.validateDate(
                                                                          d
                                                                        )
                                                                          ? _c(
                                                                              "v-list-item",
                                                                              {
                                                                                staticClass:
                                                                                  "px-3",
                                                                                attrs:
                                                                                  {
                                                                                    ripple: false,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.resendInvitations(
                                                                                        d
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-list-item-title",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Reenviar invitación"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm.$helpers.hasPermission(
                                                                          [
                                                                            "delete_invitation",
                                                                          ]
                                                                        )
                                                                          ? _c(
                                                                              "v-list-item",
                                                                              {
                                                                                staticClass:
                                                                                  "px-3",
                                                                                attrs:
                                                                                  {
                                                                                    ripple: false,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.handlerDeleteInvitation(
                                                                                        index
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-list-item-title",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Cancelar invitación"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-sheet",
                                                                  {
                                                                    staticClass:
                                                                      "transparent",
                                                                    attrs: {
                                                                      height:
                                                                        "25",
                                                                    },
                                                                  },
                                                                  [
                                                                    d.name
                                                                      .length
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey-700--text font-weight-medium body-1 d-inline-block text-truncate",
                                                                            staticStyle:
                                                                              {
                                                                                "max-width":
                                                                                  "99%",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "text-capitalize",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "lower"
                                                                                    )(
                                                                                      d.name
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "body-2 text--disabled font-italic",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Sin especificar"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            d.email.length
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "mt-n2 d-block body-2 grey-300--text d-inline-block text-truncate",
                                                                    staticStyle:
                                                                      {
                                                                        "max-width":
                                                                          "99%",
                                                                        "line-height":
                                                                          "22px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        d.email
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "body-2 text--disabled font-italic",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Sin especificar"
                                                                    ),
                                                                  ]
                                                                ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-block d-flex mt-3 justify-space-between",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 grey-300--text",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Enviado el: "
                                                                        ),
                                                                        d.sent
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "d-block",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "dateTime"
                                                                                    )(
                                                                                      d.sent
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "body-2 text--disabled font-italic",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Sin especificar"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "body-2 grey-300--text ml-5",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.validateDate(
                                                                                d
                                                                              )
                                                                                ? "Expirado"
                                                                                : "Expira"
                                                                            ) +
                                                                            " el: "
                                                                        ),
                                                                        d.due_date
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "d-block",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "dateTime"
                                                                                    )(
                                                                                      d.due_date
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "body-2 text--disabled font-italic",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Sin especificar"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("VMainPagination", {
                                key: "",
                                staticClass: "mt-5",
                                attrs: {
                                  count: _vm.invitationsList?.length,
                                  currentPage: _vm.currentPage,
                                },
                                on: {
                                  isActive: function ($event) {
                                    return _vm.setQueryInvitations($event)
                                  },
                                },
                              }),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm.loadingInactiveMembers
                    ? _c("skeleton-list")
                    : ["Inactive", null].includes(
                        ((_vm.$route || {}).query || {}).status || null
                      )
                    ? [
                        _vm.inactiveMembersList.length &&
                        _vm.$helpers.hasPermission(["view_member"])
                          ? [
                              _c(
                                "v-col",
                                {
                                  staticClass: "my-2 px-0",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-toolbar-title",
                                    {
                                      staticClass:
                                        "subtitle-1 grey-700--text font-weight-bold",
                                    },
                                    [_vm._v("Usuarios inactivos")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-row",
                                    _vm._l(
                                      _vm.inactiveMembersList,
                                      function (d, index) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: `${d.id}-${index}`,
                                            attrs: {
                                              cols: "4",
                                              md:
                                                _vm.$vuetify.breakpoint.width <
                                                1200
                                                  ? 3
                                                  : 2,
                                            },
                                          },
                                          [
                                            _c("v-hover", {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ hover }) {
                                                      return [
                                                        _c(
                                                          "v-card",
                                                          {
                                                            staticClass:
                                                              "pa-5 rounded-md",
                                                            attrs: {
                                                              elevation: hover
                                                                ? 5
                                                                : 0,
                                                              flat: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.menuInactiveMember[
                                                                  index
                                                                ] = true
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                attrs: {
                                                                  "no-gutters":
                                                                    "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mb-1",
                                                                    attrs: {
                                                                      color:
                                                                        "grey-900",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-account"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("v-spacer"),
                                                                _c(
                                                                  "v-menu",
                                                                  {
                                                                    attrs: {
                                                                      "close-on-click":
                                                                        "",
                                                                      "offset-y":
                                                                        "",
                                                                      left: "",
                                                                      "nudge-bottom": 0,
                                                                      "nudge-left": 25,
                                                                      transition:
                                                                        "slide-y-transition",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "activator",
                                                                            fn: function ({
                                                                              on,
                                                                              attrs,
                                                                            }) {
                                                                              return [
                                                                                _c(
                                                                                  "v-btn",
                                                                                  _vm._g(
                                                                                    _vm._b(
                                                                                      {
                                                                                        staticClass:
                                                                                          "mt-n1 mr-n2",
                                                                                        attrs:
                                                                                          {
                                                                                            text: "",
                                                                                            ripple: false,
                                                                                          },
                                                                                      },
                                                                                      "v-btn",
                                                                                      attrs,
                                                                                      false
                                                                                    ),
                                                                                    on
                                                                                  ),
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "grey-700",
                                                                                            size: "24",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-dots-vertical"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            },
                                                                          },
                                                                        ],
                                                                        null,
                                                                        true
                                                                      ),
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .menuInactiveMember[
                                                                          index
                                                                        ],
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.menuInactiveMember,
                                                                            index,
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "menuInactiveMember[index]",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                      },
                                                                      [
                                                                        _vm.$helpers.hasPermission(
                                                                          [
                                                                            "change_member",
                                                                          ]
                                                                        )
                                                                          ? _c(
                                                                              "v-list-item",
                                                                              {
                                                                                staticClass:
                                                                                  "px-3",
                                                                                attrs:
                                                                                  {
                                                                                    ripple: false,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.deleteMember(
                                                                                        "inactive",
                                                                                        index
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-list-item-title",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-2",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Activar usuario"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-sheet",
                                                                  {
                                                                    staticClass:
                                                                      "transparent",
                                                                    attrs: {
                                                                      height:
                                                                        "25",
                                                                    },
                                                                  },
                                                                  [
                                                                    d.first_name
                                                                      .length &&
                                                                    d.first_name !==
                                                                      " "
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "grey-700--text font-weight-medium body-1 d-inline-block text-truncate",
                                                                            staticStyle:
                                                                              {
                                                                                "max-width":
                                                                                  "99%",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "text-capitalize",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "lower"
                                                                                    )(
                                                                                      d.first_name
                                                                                    )
                                                                                  ) +
                                                                                    " " +
                                                                                    _vm._s(
                                                                                      _vm._f(
                                                                                        "lower"
                                                                                      )(
                                                                                        d.last_name
                                                                                      )
                                                                                    )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "body-2 text--disabled font-italic",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Sin especificar"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            d.email.length
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "mt-n2 d-block body-2 grey-300--text d-inline-block text-truncate",
                                                                    staticStyle:
                                                                      {
                                                                        "max-width":
                                                                          "99%",
                                                                        "line-height":
                                                                          "22px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        d.email
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "d-block mt-n1 body-2 text--disabled",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Sin especificar"
                                                                    ),
                                                                  ]
                                                                ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { attrs: { id: "inactive" } }),
                              _c("VMainPagination", {
                                key: "Inactive",
                                staticClass: "mt-5",
                                attrs: {
                                  count: _vm.inactiveMembersList?.length,
                                  currentPage: _vm.currentPageInactive,
                                },
                                on: {
                                  isActive: function ($event) {
                                    return _vm.setQueryMembers(
                                      $event,
                                      "Inactive"
                                    )
                                  },
                                },
                              }),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  !_vm.loadingInactiveMembers &&
                  !_vm.loadingInvitations &&
                  !_vm.loadingActiveMembers
                    ? [
                        !_vm.activeMembersList.length &&
                        !_vm.inactiveMembersList.length &&
                        !_vm.instanceInvitationsList.length
                          ? _c(
                              "v-col",
                              { staticClass: "px-0", attrs: { cols: "12" } },
                              [
                                _c("v-empty-state", {
                                  attrs: {
                                    type: "users",
                                    id: "Usuarios",
                                    isFree: true,
                                    title: "No existen usuarios",
                                    customClass: "mt-5",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
          ]
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogCreate,
            callback: function ($$v) {
              _vm.dialogCreate = $$v
            },
            expression: "dialogCreate",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "", outlined: "", rounded: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-semibold",
                    },
                    [_vm._v("Invitar personas a " + _vm._s(_vm.account.name))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialogCreate = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pl-5 pr-0 py-4" },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center", "no-gutters": "" } },
                    [
                      _vm.invitations.length === 1
                        ? _c("v-col", { attrs: { cols: "3" } }, [
                            _c("img", {
                              attrs: {
                                src: require(`@/assets/backgrounds/modal-member.svg`),
                                width: 148,
                              },
                            }),
                          ])
                        : _vm._e(),
                      _c(
                        "v-col",
                        { staticClass: "pr-0 pl-1" },
                        [
                          _c(
                            "v-list-item-subtitle",
                            [
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0",
                                      attrs: { cols: "7" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-1 grey-500--text font-weight-medium",
                                        },
                                        [_vm._v("Email")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0 pl-3",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-1 grey-500--text font-weight-medium",
                                        },
                                        [_vm._v("Nombre")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._l(_vm.invitations, function (d, i) {
                                return _c(
                                  "v-row",
                                  { key: i, attrs: { "no-gutters": "" } },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "py-1 pl-0 pr-2",
                                        attrs: { cols: "7" },
                                      },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            error:
                                              _vm.$v.invitations.$each[i].email
                                                .$error,
                                            "hide-details": "",
                                            maxlength: "254",
                                            outlined: "",
                                            required: "",
                                            "single-line": "",
                                            dense: "",
                                          },
                                          model: {
                                            value:
                                              _vm.$v.invitations.$each[i].email
                                                .$model,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.$v.invitations.$each[i]
                                                  .email,
                                                "$model",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "$v.invitations.$each[i].email.$model",
                                          },
                                        }),
                                        ((_vm.invitations || [])[i] || {}).email
                                          .length
                                          ? [
                                              !_vm.$v.invitations.$each[i].email
                                                .isUser
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "red--text caption py-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Ya es usuario de la cuenta"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              !_vm.$v.invitations.$each[i].email
                                                .isInvited
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "red--text caption py-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Tiene una invitación pendiente"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "py-1 pl-1 pr-0" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            error:
                                              _vm.$v.invitations.$each[i].name
                                                .$error,
                                            "hide-details": "",
                                            outlined: "",
                                            "single-line": "",
                                            dense: "",
                                          },
                                          model: {
                                            value:
                                              _vm.$v.invitations.$each[i].name
                                                .$model,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.$v.invitations.$each[i]
                                                  .name,
                                                "$model",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "$v.invitations.$each[i].name.$model",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mr-3 pl-1",
                                        staticStyle: { "max-width": "40px" },
                                      },
                                      [
                                        i >= 1 || _vm.invitations.length > 1
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  text: "",
                                                  color: "grey-700",
                                                  ripple: false,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.invitations.splice(
                                                      i,
                                                      1
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color: "grey-900",
                                                    },
                                                  },
                                                  [_vm._v("mdi-delete")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "pa-0" },
                                    [
                                      _vm.invitations.length < 10
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "mt-n1",
                                              attrs: {
                                                text: "",
                                                color: "grey-900",
                                                ripple: false,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.addRowInvitations.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("mdi-plus")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-medium body-1",
                                                },
                                                [_vm._v("Agregar otro")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogCreate = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { loading: _vm.createLoader, color: "grey-900" },
                      on: { click: _vm.handleInvitations },
                    },
                    [_vm._v("Enviar invitaciones")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDelete,
            callback: function ($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.deletecurrentMember.is_active
                                ? "Desactivar"
                                : "Activar"
                            ) + " usuario"
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogDelete = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", { staticClass: "py-4 px-5 grey-500--text" }, [
                _c("span", { staticClass: "d-block" }, [
                  _vm._v(
                    "¿Qué ocurre cuando se " +
                      _vm._s(
                        _vm.deletecurrentMember.is_active
                          ? "desactiva"
                          : "activa"
                      ) +
                      " un usuario?"
                  ),
                ]),
                _c("span", { staticClass: "d-block mt-4" }, [
                  _vm._v(
                    "1. El usuario " +
                      _vm._s(_vm.deletecurrentMember.is_active ? "ya no" : "") +
                      " podrá trabajar en el espacio de trabajo."
                  ),
                ]),
                _c("span", { staticClass: "d-block mt-2 mb-3" }, [
                  _vm._v(
                    "2. Toda la información creada por el usuario seguirá estando disponible."
                  ),
                ]),
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDelete = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.deleteMember },
                    },
                    [_vm._v("Continuar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDeleteInvitation,
            callback: function ($$v) {
              _vm.dialogDeleteInvitation = $$v
            },
            expression: "dialogDeleteInvitation",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Eliminar invitación")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogDeleteInvitation = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c("span", { staticClass: "d-block" }, [
                    _vm._v(
                      _vm._s(
                        (
                          _vm.invitationsList[_vm.currentDeleteInvitationID] ||
                          []
                        ).email || ""
                      ) +
                        " no podrá unirse a " +
                        _vm._s(_vm.account.name)
                    ),
                  ]),
                  _c("span", { staticClass: "d-block mt-4 mb-3" }, [
                    _vm._v("Escribe "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v("“confirmar”"),
                    ]),
                    _vm._v(" para continuar."),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      "single-line": "",
                      maxlength: "9",
                      dense: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.confirm,
                      callback: function ($$v) {
                        _vm.confirm = $$v
                      },
                      expression: "confirm",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDeleteInvitation = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.deleteInvitation },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }